// extracted by mini-css-extract-plugin
export default {"container":"CopyButton_container__LKALO","tooltip":"CopyButton_tooltip__JUZCh","button":"CopyButton_button__dXPa+"};